import {apiRequest} from "./client";

export async function subscribeNewsletter(data: {nume: string; email: string}): Promise<{ok: boolean}> {
  return apiRequest<{ok: boolean}>("/newsletter/subscribe", {method: "POST", body: data});
}

export async function unsubscribeNewsletter(hash: string): Promise<{ok: boolean}> {
  return apiRequest<{ok: boolean}>(`/newsletter/unsubscribe/${encodeURIComponent(hash)}`, {method: "POST"});
}
